import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormFeedback,
} from "reactstrap"
import Select from "react-select"

import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import { useFormik } from "formik"
import Dropzone from "react-dropzone"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import SuccessPopup from "../../../components/SuccessPopup"
import ErrorPopup from "../../../components/ErrorPopup"
import {
  createPvsSubcategory,
  resetPvsSubcategoryState,
  fetchPvsCategory,
} from "../../../redux/actions/pvs"

function AddPvsSubcategory() {
  document.title = "Add Pvs Subcategory | PVS | Admin Dashboard"

  const history = useNavigate()
  const dispatch = useDispatch()

  const pvsState = useSelector(state => state.pvs)
  const createSubcategoryScreen = useSelector(
    state => state.screens.pvs.createPvsSubcategory
  )

  const [successOpen, setSuccessOpen] = useState(false)
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const [selectedPvsSubcategoryFiles, setSelectedPvsSubcategoryFiles] =
    useState([])

  const categoryOptions = (pvsState.categoryList || []).map(c => ({
    value: c.enc_pvs_cat_id,
    label: c.category,
  }))

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      subcategory: "",
      categories: "",
      description: "",
    },
    validationSchema: Yup.object({
      subcategory: Yup.string().required("Please Enter Subcategory Name"),
      categories: Yup.string().required("Please Select Category"),
      // description: Yup.string().required("Please Enter Description"),
    }),
    onSubmit: values => {
      const formData = new FormData()
      // Append text fields
      formData.append("subcategory", values.subcategory)
      formData.append("description", values.description)
      formData.append("enc_pvs_cat_id", values.categories)
      // formData.append("enc_pvs_cat_id", "28b9f95907a1ecf4c85af58cca03df55:590030855497d79ef8ffb5716f0326bf");
      if (selectedPvsSubcategoryFiles[0])
        formData.append("pvs_subcategory_icon", selectedPvsSubcategoryFiles[0])
      dispatch(createPvsSubcategory(formData))
    },
  })
  useEffect(() => {
    if (createSubcategoryScreen.success) {
      setSuccessOpen(true)
    } else if (createSubcategoryScreen.error) {
      setErrorMsg(createSubcategoryScreen.message)
      setErrorOpen(true)
    }
  }, [createSubcategoryScreen])
  useEffect(() => {
    dispatch(fetchPvsCategory())
  }, [dispatch])

  return (
    <React.Fragment>
      <SuccessPopup
        isOpen={successOpen}
        toggle={() => setSuccessOpen(false)}
        onConfirm={() => {
          setSuccessOpen(false)
          dispatch(resetPvsSubcategoryState())
          history("/pvs-subcategory", { replace: true })
        }}
        message={"Subcategory Added Successfully!"}
      />
      <ErrorPopup
        isOpen={errorOpen}
        toggle={() => {
          setErrorOpen(false)
          dispatch(resetPvsSubcategoryState())
        }}
        message={errorMsg}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="PVS"
            title="Subcategory"
            breadcrumbItem="Add PVS Subcategory"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="subcategory">
                          Subcategory <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="subcategory"
                          className="form-control"
                          placeholder="Enter subcategory name"
                          type="text"
                          id="subcategory"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subcategory || ""}
                          invalid={
                            validation.touched.subcategory &&
                            validation.errors.subcategory
                              ? true
                              : false
                          }
                        />
                        {validation.touched.subcategory &&
                        validation.errors.subcategory ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subcategory}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="categories">
                          Category <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="categories"
                          name="categories"
                          options={categoryOptions}
                          value={
                            categoryOptions.find(
                              option =>
                                option.value === validation.values.categories
                            ) || null
                          }
                          onChange={option =>
                            validation.setFieldValue(
                              "categories",
                              option ? option.value : ""
                            )
                          }
                          onBlur={() =>
                            validation.setFieldTouched("categories", true)
                          }
                          placeholder="Select Category"
                        />
                        {validation.touched.categories &&
                        validation.errors.categories ? (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "0.875em" }}
                          >
                            {validation.errors.categories}
                          </div>
                        ) : null}
                      </div>
                      {/*                <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="categories">
                            Category <span className="text-danger">*</span>
                          </Label>
                          <Select
                            id="categories"
                            name="categories"
                            // isMulti
                            options={categoryOptions}
                            classNamePrefix="select"
                            placeholder="Type or select categories..."
                            value={validation.values.categories || []}
                            onChange={selected => validation.setFieldValue('categories', selected)}
                            isClearable
                            isSearchable
                            noOptionsMessage={() => 'Type to add new category'}
                            formatCreateLabel={inputValue => `Add "${inputValue}"`}
                            isValidNewOption={() => true}
                          />
                          {validation.touched.categories && validation.errors.categories ? (
                            <FormFeedback type="invalid">{validation.errors.categories}</FormFeedback>
                          ) : null}
                        </div> */}
                      <div className="mb-3 col-md-6">
                        <Label className="form-label" htmlFor="description">
                          Description
                        </Label>
                        <textarea
                          name="description"
                          id="description"
                          className={`form-control ${
                            validation.touched.description &&
                            validation.errors.description
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                        />
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3 col-md-6">
                        <Label
                          className="form-label"
                          htmlFor="pvs_subcategory_icon"
                        >
                          PVS Subcategory Icon
                        </Label>
                        <Dropzone
                          onDrop={acceptedFiles => {
                            setSelectedPvsSubcategoryFiles(acceptedFiles)
                            validation.setFieldValue(
                              "pvs_subcategory_icon",
                              acceptedFiles[0]
                            )
                          }}
                          multiple={false}
                          accept={{ "image/*": [] }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="mdi mdi-cloud-upload display-4 text-muted"></i>
                                </div>
                                <h4>Drop files here or click to upload.</h4>
                                {/*   <div className="text-muted mb-2" style={{ fontSize: '0.55em' }}>
                                    Image size must be <b>416 × 208 px</b>
                                  </div> */}
                                {selectedPvsSubcategoryFiles &&
                                  selectedPvsSubcategoryFiles.length > 0 && (
                                    <div className="mt-2">
                                      <img
                                        src={URL.createObjectURL(
                                          selectedPvsSubcategoryFiles[0]
                                        )}
                                        alt="Icon Preview"
                                        style={{
                                          maxWidth: "200px",
                                          maxHeight: "120px",
                                          borderRadius: "4px",
                                          border: "1px solid #eee",
                                        }}
                                      />
                                    </div>
                                  )}
                                {/*    {(!selectedPvsSubcategoryFiles || selectedPvsSubcategoryFiles.length === 0) && userPvsData?pvs_subcategory_icon_path && (
                                    <div className="mt-2">
                                      <img
                                        src={userPvsDatapvs_subcategory_icon_path}
                                        alt="Icon Front"
                                        style={{ maxWidth: '200px', maxHeight: '120px', borderRadius: '4px', border: '1px solid #eee' }}
                                      />
                                    </div>
                                  )} */}
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        {/* View File link outside Dropzone, centered */}
                        {selectedPvsSubcategoryFiles &&
                          selectedPvsSubcategoryFiles.length > 0 && (
                            <div className="mt-1 d-flex justify-content-center">
                              <a
                                href={URL.createObjectURL(
                                  selectedPvsSubcategoryFiles[0]
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View File
                              </a>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <Button
                        type="submit"
                        color="primary"
                        size="lg"
                        className="mt-3"
                      >
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AddPvsSubcategory
